import { useTranslation } from "react-i18next";

const KEYS = [
  "intro", "data", "usage", "basis", "sharing", "retention", "rights", "security", "changes", "contact",
];

export default function Privacy() {
  const { t } = useTranslation();
  return (
    <article className="legal-page" data-testid="privacy-page">
      <div className="legal-inner">
        <span className="eyebrow">{t("nav.legal")}</span>
        <h1 className="h-display legal-title">{t("privacy.title")}</h1>
        <p className="legal-updated">{t("privacy.updated")}</p>
        {KEYS.map((k) => (
          <section className="legal-section" key={k}>
            <h2 className="legal-h2">{t(`privacy.${k}Title`)}</h2>
            <p className="legal-body">{t(`privacy.${k}Text`)}</p>
          </section>
        ))}
      </div>
    </article>
  );
}
